import { createRouter, createWebHashHistory } from "vue-router";
import RecapCommande from "../components/RecapCommande.vue";
import HomeView from "../views/HomeView.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/recap",
    name: "recap",
    component: RecapCommande,
  },
  {
    path: "/*",
    component: HomeView,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
